<script>
import {computed, getCurrentInstance} from 'vue';
export default {
  props: {
    propsData: {
      type: Array,
      default: () => [],
    },
    isMore: {
      default: false,
      type: Boolean,
    },
    rowIndex: {
      default: 0,
      type: Number,
    },
    dataRow: {},
    col: {
      default: () => {},
      type: Object,
    },
  },

  setup(props) {
    const {proxy} = getCurrentInstance();
    /**
     * Thêm tooltip cho icon
     * NXCHIEN 24.07.2022
     */
    const getToolTip = value => {
      switch (value) {
        case 'Insert':
          return 'Thêm dòng';
        case 'Update':
          return 'Sửa dòng';
        case 'Delete':
          return 'Xóa dòng';
      }
    };

    /**
     * Custom lại propsData để build action cho từng dòng theo row_action_type (Xem chi tiết tại constant RowActionType)
     * NVTUAN1 28.09.2022
     */
    const propsDataCustom = computed(() => {
      let propsDataCustom = [];

      //Nếu không có config row_action_type thì mặc định trả về các chức năng được config trong rowAction ở propsData
      if (!props.dataRow.row_action_type) {
        return props.propsData;
      }

      switch (props.dataRow.row_action_type) {
        case proxy.$ms.constant.RowActionType.View:
          propsDataCustom = ['View'];
          break;
        case proxy.$ms.constant.RowActionType.Insert:
          propsDataCustom = ['Insert'];
          break;
        case proxy.$ms.constant.RowActionType.Update:
          propsDataCustom = ['Update'];
          break;
        case proxy.$ms.constant.RowActionType.Delete:
          propsDataCustom = ['Delete'];
          break;
        case proxy.$ms.constant.RowActionType.DeleteCustom:
          propsDataCustom = ['DeleteCustom'];
          break;
        case proxy.$ms.constant.RowActionType.None:
          propsDataCustom = [];
          break;
        default:
          propsDataCustom = props.propsData;
          break;
      }

      return propsDataCustom;
    });

    /**
     * Text action
     * TTLONG 09/09/2022
     */
    const getActionText = value => {
      switch (value) {
        case 'Insert':
          return 'Thêm';
        case 'Delete':
          return 'Xóa';
        case 'View':
          return 'Xem';
      }
    };
    const dbOptionHeight = computed(() => {
      return 'heightoptionvalue' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });
    return {
      propsDataCustom,
      getToolTip,
      getActionText,
      dbOptionHeight,
    };
  },
};
</script>

<template>
  <div class="cell-action">
    <div
      v-for="(item, index) in propsDataCustom"
      class="row-editor-action"
      :key="index"
      v-tooltip="getToolTip(item)"
      :class="[
        col.displayType !== $ms.constant.DisplayColumnType.Text ? item.toString().toLowerCase() + ' icon24' : '',
        {'before-last': index <= propsDataCustom.length - 2},
        {'drag-data': item.toString().toLowerCase() === 'drag'},
        dbOptionHeight,
      ]"
      @click="$emit('gridRowActionClick', item, rowIndex)"
    >
      {{ col.displayType !== $ms.constant.DisplayColumnType.Text ? '' : getActionText(item) }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.before-last {
  margin-right: 4px;
}
.drag-data {
  cursor: move;
}

.cell-action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  .row-editor-action {
    color: $blue;
    font-weight: 600;
  }
  .icon24 {
    &.heightoptionvalue1 {
      height: $input-height-custom-small-with-border !important;
      min-height: $input-height-custom-small-with-border !important;
    }
  }
  .heightoptionvalue2 {
    min-height: $input-height-custom-big-with-border !important;
  }
}
</style>
